module.exports = __webpack_public_path__ + "img/antonio-di-marino.47944f3e.jpg";